module.exports = __webpack_public_path__ + "img/upload_info_s_png.0ae7eef4.svg";